import state from './userservicedivision.state'
import mutations from './userservicedivision.mutations'
import actions from './userservicedivision.actions'

export default {
  state,
  mutations,
  actions
}
